__turbopack_context__.v({
  "cards": "table-module__t09zua__cards",
  "label": "table-module__t09zua__label",
  "sortHeadingControl": "table-module__t09zua__sortHeadingControl",
  "sortHeadingLabel": "table-module__t09zua__sortHeadingLabel",
  "value": "table-module__t09zua__value",
});
